import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconFileText: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.1087 7.05833L12.1087 2.05833C11.9912 1.94083 11.8328 1.875 11.667 1.875H6.66699C4.65199 1.875 3.54199 2.985 3.54199 5V15C3.54199 17.015 4.65199 18.125 6.66699 18.125H14.167C16.182 18.125 17.292 17.015 17.292 15V7.5C17.292 7.33417 17.2262 7.175 17.1087 7.05833ZM12.292 4.00917L15.1578 6.875H14.167C12.8528 6.875 12.292 6.31417 12.292 5V4.00917ZM14.167 16.875H6.66699C5.35283 16.875 4.79199 16.3142 4.79199 15V5C4.79199 3.68583 5.35283 3.125 6.66699 3.125H11.042V5C11.042 7.015 12.152 8.125 14.167 8.125H16.042V15C16.042 16.3142 15.4812 16.875 14.167 16.875ZM13.9587 10C13.9587 10.345 13.6787 10.625 13.3337 10.625H7.50033C7.15533 10.625 6.87533 10.345 6.87533 10C6.87533 9.655 7.15533 9.375 7.50033 9.375H13.3337C13.6787 9.375 13.9587 9.655 13.9587 10ZM11.4587 13.3333C11.4587 13.6783 11.1787 13.9583 10.8337 13.9583H7.50033C7.15533 13.9583 6.87533 13.6783 6.87533 13.3333C6.87533 12.9883 7.15533 12.7083 7.50033 12.7083H10.8337C11.1787 12.7083 11.4587 12.9883 11.4587 13.3333Z"
      fill={color}
    />
  </svg>
);

export default IconFileText;
